import ko from './ko';
import en from './en';

export default {
    ko,
    en
}